<span class="star-rating" [attr.aria-label]="'Avaliação ' + (value || 0) + ' de 5'">
  @for (star of stars; track star) {
    <i class="bi" [ngClass]="iconClass(star)"></i>
  }
</span>
